<template>
  <div>
    <br>
    <div class="columns is-mobile is-multiline">
      <div
        v-for="product in masks"
        :key="product.name"
        class="column is-full-mobile is-half-tablet is-one-third-desktop is-one-quarter-fullhd"
      >
        <product-card-info :product-info="product" />
      </div>
    </div>
    <model-collada src="3d/knife.dae">
        </model-collada>
  </div>
</template>

<script>
import ProductCardInfo from '../components/ProductCardInfo'
import { ModelCollada } from 'vue-3d-model'

export default {
  components: {
    ProductCardInfo,
    ModelCollada
  },
  data () {
    return {
      masks: [
        {
          name: 'Fabric Masks',
          images: [
            {
              title: 'Slide 1',
              image: 'img/masks/IMG_6071.webp'
            },
            {
              title: 'Slide 1',
              image: 'img/masks/IMG_6072.webp'
            },
            {
              title: 'Slide 1',
              image: 'img/masks/IMG_6073.webp'
            },
            {
              title: 'Slide 1',
              image: 'img/masks/IMG_6075.webp'
            },
            {
              title: 'Slide 1',
              image: 'img/masks/IMG_6075.webp'
            },
            {
              title: 'Slide 1',
              image: 'img/masks/IMG_6075.webp'
            }
          ],
          description: 'All masks are handcrafted. fabrics and design can be individually selected.'
        },
        {
          name: 'Fabric Masks',
          images: [
            {
              title: 'Slide 1',
              image: 'img/masks/IMG_6071.webp'
            },
            {
              title: 'Slide 1',
              image: 'img/masks/IMG_6072.webp'
            },
            {
              title: 'Slide 1',
              image: 'img/masks/IMG_6073.webp'
            },
            {
              title: 'Slide 1',
              image: 'img/masks/IMG_6075.webp'
            },
            {
              title: 'Slide 1',
              image: 'img/masks/IMG_6075.webp'
            },
            {
              title: 'Slide 1',
              image: 'img/masks/IMG_6075.webp'
            }
          ],
          description: 'All masks are handcrafted. fabrics and design can be individually selected.'
        },
        {
          name: 'Paper Masks',
          images: [
            {
              title: 'Slide 1',
              image: 'img/masks/IMG_1193.jpg'
            }
          ],
          description: 'All masks are handcrafted. fabrics and design can be individually selected.'
        }
      ]
    }
  }
}
</script>
